import React from 'react';
import VoucherRedemption from './voucher';

class OrderSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view_more_active: false,
      view_mode: 'SUMMARY',
      isSummaryOpened: true,
      isBasketOpened: true,
      view_more_max_height: 0,
      progress: 'start',
    };

    this.toggleSummaryViewMode = this.toggleSummaryViewMode.bind(this);
    this.toggleBasketViewMode = this.toggleBasketViewMode.bind(this);
    this.formatAddress = this.formatAddress.bind(this);
  }
  componentDidMount() {
    if (document.body.getBoundingClientRect().width < 767) {
      this.setState({
        isSummaryOpened: false,
        isBasketOpened: false,
      });
    }
  }
  componentWillReceiveProps(props) {
    this.setState({
      progress: props.progress,
    });
  }
  toggleSummaryViewMode() {
    this.setState(oldState => ({
      isSummaryOpened: !oldState.isSummaryOpened,
    }));
  }
  toggleBasketViewMode() {
    this.setState(oldState => ({ isBasketOpened: !oldState.isBasketOpened }));
  }

  formatAddress(line) {
    if (line != '') {
      return line + ', ';
    } else {
      return '';
    }
  }

  render() {
    const { orderApprovalsEnabled } = this.props;
    var deliveryDate =
      this.props.summary.delivery_date === '' ? (
        ''
      ) : (
        <span className="delivery--summary">
          <strong>Delivery Date:</strong>
          <br />
          {this.props.summary.delivery_date}
          <br />
          <br />
          <strong>Delivery Service:</strong> <br />
          {this.props.summary.delivery_service_description}
        </span>
      );

    var deliveryCharge =
      this.props.summary.delivery === '0.00' ? (
        'Free'
      ) : (
        <span>&pound;{this.props.summary.delivery}</span>
      );
    var delivery =
      this.props.summary.delivery_set === false ? (
        ''
      ) : (
        <li>
          Delivery <span className="price">{deliveryCharge}</span>
        </li>
      );
    var deliveryAddress =
      this.props.orderType === 'COLLECTION' ? (
        ''
      ) : (
        <div
          className={
            'address ' + (this.props.orderType === 'MIXED' ? 'mixed-order' : '')
          }>
          <div
            className={
              'selected-address ' +
              (this.state.view_more_active === true ? ' mini-view' : '')
            }>
            {this.props.deliveryAddress.delivery_address1 != '' ? (
              <ul>
                <li>
                  <strong>Delivery Details</strong>
                </li>
                <li>
                  <strong>{this.props.deliveryAddress.name}</strong>
                </li>
                {this.props.deliveryAddress && (
                  <li>
                    <p>
                      {this.formatAddress(this.props.deliveryAddress.line1)}
                      {this.formatAddress(this.props.deliveryAddress.line2)}
                      {this.formatAddress(this.props.deliveryAddress.line3)}
                      {this.formatAddress(this.props.deliveryAddress.line4)}
                      {this.formatAddress(this.props.deliveryAddress.line5)}
                      {this.props.deliveryAddress.postcode}
                    </p>
                  </li>
                )}
              </ul>
            ) : (
              ''
            )}
          </div>
        </div>
      );
    var collectionAddress =
      this.props.orderType === 'DELIVERY' ? (
        ''
      ) : (
        <div
          className={
            'address ' + (this.props.orderType === 'MIXED' ? 'mixed-order' : '')
          }>
          <div
            className={
              'selected-address ' +
              (this.state.view_more_active === true ? ' mini-view' : '')
            }>
            <ul>
              <li>
                <strong>Collection Store</strong>
              </li>
              <li>
                <strong>{this.props.collectionAddress.name}</strong>
              </li>
              <p>
                {this.formatAddress(this.props.collectionAddress.line_1)}
                {this.formatAddress(this.props.collectionAddress.line_2)}
                {this.formatAddress(this.props.collectionAddress.line_3)}
                {this.formatAddress(this.props.collectionAddress.line_4)}
                {this.formatAddress(this.props.collectionAddress.line_5)}
                {this.props.collectionAddress.postcode}
              </p>
            </ul>
          </div>
        </div>
      );

    var total =
      this.props.summary.type !== 'MIXED' ? (
        <li className="total">
          <strong>
            Total{' '}
            <span className="price">&pound;{this.props.summary.total}</span>
          </strong>
        </li>
      ) : (
        <span>
          <li className="total no-top-border">
            <strong>
              Delivery Total{' '}
              <span className="price">
                &pound;{this.props.summary.total_delivery_items_with_carriage}
              </span>
            </strong>
          </li>
          <li className="total">
            <strong>
              Collection Total{' '}
              <span className="price">
                &pound;{this.props.summary.total_collection_items}
              </span>
            </strong>
          </li>
        </span>
      );
    var voucher_redemption =
      this.props.orderType != 'COLLECTION' && !orderApprovalsEnabled ? (
        <VoucherRedemption
          voucherApplied={this.props.voucherApplied}
          voucherUrl={this.props.voucherUrl}
          voucherSavings={this.props.voucherSavings}
          getSummary={this.props.getSummary}
          viewMoreActive={this.state.view_more_active}
          currentStep={this.props.currentStep}
          processingState={this.props.processingState}
          orderType={this.props.orderType}
        />
      ) : (
        ''
      );

    return (
      <div
        className="order-summary-container"
        data-spy="affix2"
        data-offset-top="340">
        <div className="order-summary">
          <div className="progress">
            <div className={'p ' + this.state.progress} />
          </div>
          <h5 onClick={this.toggleSummaryViewMode}>
            <strong>Order Summary</strong>
            <i
              className={
                'pull-right ' +
                (this.state.isSummaryOpened
                  ? 'icon-chevron-up'
                  : 'icon-chevron-down')
              }
            />
          </h5>
          <div
            className={
              this.state.isSummaryOpened
                ? 'summary-content'
                : 'summary-content hidden'
            }>
            <div className={'details full'}>
              <ul className="summary">
                <li>
                  Goods total{' '}
                  <span className="price">
                    &pound;{this.props.summary.goods_total}
                  </span>
                </li>
                {delivery}
                <li>
                  VAT{' '}
                  <span className="price">&pound;{this.props.summary.vat}</span>
                </li>
                {total}
              </ul>
            </div>
            {collectionAddress}
            {deliveryAddress}
            <br />
            {deliveryDate}
          </div>
        </div>

        <div
          className={
            'order-summary basket-summary ' +
            (this.state.view_mode === 'SUMMARY' ? ' no-bottom-padding' : ' ')
          }>
          <h5 onClick={this.toggleBasketViewMode}>
            <strong>Your Basket</strong>({this.props.summary.title})
            <i
              className={
                'pull-right ' +
                (this.state.isBasketOpened
                  ? 'icon-chevron-up'
                  : 'icon-chevron-down')
              }
            />
          </h5>
          <table
            className={
              'basket-items ' +
              (this.state.isBasketOpened
                ? 'summary-content'
                : 'summary-content hidden')
            }>
            <tbody>
              {this.props.summary.delivery_lines && (
                <tr>
                  <td colSpan="3" className="line-type-title">
                    Delivery Items
                  </td>
                </tr>
              )}
              {this.props.summary.lines.map((line, index) => {
                var deliveryIcon = <span className="line-type">Delivery </span>;
                if (line.type === 'DeliveryBasketLine') {
                  return (
                    <tr key={index}>
                      <td>
                        <img
                          src={line.thumbnail}
                          className="product-image"
                          alt=""
                        />
                      </td>
                      <td>
                        {line.description}
                        <span className="line-price">
                          &pound;{line.goods}
                          {deliveryIcon}
                        </span>
                      </td>
                      <td>QTY: {line.quantity}</td>
                    </tr>
                  );
                }
              })}

              {this.props.summary.collection_lines && (
                <tr>
                  <td colSpan="3" className="line-type-title">
                    Collection Items
                  </td>
                </tr>
              )}
              {this.props.summary.lines.map((line, index) => {
                var deliveryIcon = (
                  <span className="line-type">Collection </span>
                );
                if (line.type != 'DeliveryBasketLine') {
                  return (
                    <tr key={index}>
                      <td>
                        <img
                          src={line.thumbnail}
                          className="product-image"
                          alt=""
                        />
                      </td>
                      <td>
                        {line.description}
                        <span className="line-price">
                          &pound;{line.goods}
                          {deliveryIcon}
                        </span>
                      </td>
                      <td>QTY: {line.quantity}</td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </table>
        </div>
        {voucher_redemption}
      </div>
    );
  }
}

export default OrderSummary;
